import { Controller } from "@hotwired/stimulus";
import Sortable from 'sortablejs/modular/sortable.core.esm.js';

export default class extends Controller {
  static targets = [ "root" ]
  static values = { root: String }

  connect () { 
    let _this = this;

    if (_this.hasRootTarget) {

      let sortable = Sortable.create(_this.rootTarget, {
        animation: 150,
        handle: ".sortable-icon",
        onEnd: function (event) {
          let ids = [];

          for (const child of _this.rootTarget.children) {
            ids.push(child.dataset.id);
          }

          let body = {}
          body[_this.rootValue] = {ids: ids};

          fetch(location.pathname + "/reorder", {
            method: "PUT",
            headers: {
              "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content,
              'Content-Type': 'application/json'
            },
            credentials: "same-origin",
            body: JSON.stringify(body), 
          }).then (response => response.text())
          .then(function(html) {
            console.log(html);
          });
        }
      });

    }
  }

}